// src/modules/leaves/components/RejectedLeaveModel.tsx
import { useState } from "react";
import { Form, Input, message } from "antd";
import { useTranslation } from "react-i18next";

import CustomModal from "components/Common/CustomModal";

interface RejectedLeaveModelProps {
  isOpen: boolean;
  onClose: () => void;
  leaveData?: any | null;
  onSave: (payload: any) => Promise<void> | void;
}

const RejectedLeaveModel: React.FC<RejectedLeaveModelProps> = ({
  isOpen,
  onClose,
  leaveData,
  onSave,
}) => {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    try {
      setLoading(true);
      const values = await form.validateFields();
      await onSave({ reasonReject: values.reasonReject, status: "rejected" });
    } catch (error) {
      message.error(t("errors.VALIDATION_ERROR"));
      return;
    } finally {
      setLoading(false);
    }
  };

  return (
    <CustomModal
      title={t("leave.edit")}
      isOpen={isOpen}
      onClose={onClose}
      onSave={handleSave}
      loading={loading}
      saveText={t("confirm")}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          label={t("leave.form.reasonReject")}
          name="reasonReject"
          rules={[{ required: true, message: t("leave.validation.please_enter_reasonReject") },
          {
            max: 500,
            message: t("leave.validation.reasonReject_too_long"),
          },
          ]}
        >
          <Input.TextArea
            rows={4}
            maxLength={1000}
            placeholder={t("leave.placeholders.reasonReject")}
            defaultValue={leaveData?.reasonReject || ""}
          />
        </Form.Item>
      </Form>
    </CustomModal>
  );
};

export default RejectedLeaveModel;
